import { Delete, ExpandMore } from "@mui/icons-material";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Icon,
	IconButton,
	Tooltip
} from "@mui/material";
import lod_ from "lodash";
import MDBox from "components/Basics/MDBox";
import InputType from "./InputType";
import { t } from "i18next";

const ChildAccordionArrayMapper = ({
	path,
	fieldChild,
	classes,
	values,
	root,
	rootPath,
	PI,
	listAPIs,
	userLangage,
	customErrors,
	handleInputChangeValidate,
	isEmpty,
	formDictionary,
	handleRemoveItemToArray,
	handleAddItemToArray,
	routeDict,
	contextDictionary,
	index,
	checkInputRequired,
	examplesResult = null
}) => {
	let displayedSumary = Object.keys(fieldChild)
		.map(key => {
			let item = fieldChild[key];
			if (item.type !== "data" && item.display) {
				return item.value;
			} else {
				return "";
			}
		})
		.filter(val => val)
		.join(", ");

	const getExampleSynchronisation = uuid => {
		if (lod_.isNil(examplesResult)) {
			return null;
		}

		const example = examplesResult.find(item => item.id === uuid);

		if (lod_.isNil(example)) {
			return (
				<Tooltip title={t("FORMS.EXAMPLE.notSyncro")} placement="top">
					<Icon fontSize="small" color="error">
						error
					</Icon>
				</Tooltip>
			);
		}

		return (
			<Tooltip title={t("FORMS.EXAMPLE.syncro")} placement="top">
				<Icon fontSize="small" color="success">
					check_circle
				</Icon>
			</Tooltip>
		);
	};

	return (
		<Accordion style={{ margin: "0.5em 0 0 0" }} className="customAccordion" key={index}>
			<AccordionSummary
				expandIcon={<ExpandMore />}
				aria-controls="panel1a-content"
				id="panel1a-header"
			>
				{!lod_.isNil(index) && (
					<Box
						style={{
							flex: "0 0 50px",

							display: "flex",
							alignItems: "center"
						}}
					>
						<div className={classes.numberCircle}>{index + 1}</div>
					</Box>
				)}

				<MDBox
					sx={{
						display: "flex",
						alignItems: "center"
					}}
					flex="2"
				>
					{displayedSumary}
				</MDBox>
				<MDBox display="flex" justifyContent="end" alignItems="center" width="100%" flex="1">
					{getExampleSynchronisation(fieldChild.uuid?.value)}
					<IconButton
						onClick={e => {
							handleRemoveItemToArray(index, path);
							e.stopPropagation();
						}}
					>
						<Icon fontSize="small">delete</Icon>
					</IconButton>
				</MDBox>
			</AccordionSummary>
			<AccordionDetails>
				{Object.keys(fieldChild)
					.sort((a, b) => fieldChild[a].order - fieldChild[b].order)
					.map((child, key) => {
						if (
							fieldChild[child].type === "level" &&
							fieldChild[child].isArray &&
							typeof fieldChild[child] === "object"
						) {
							return (
								<>
									{fieldChild[child].value.map((childArray, keyArray) => {
										let rootPathArray = root === "" ? `${root}` : root + `.${child}[${keyArray}]`;
										let rootPathArrayDico =
											rootPath === "" ? `${rootPath}` : rootPath + `.${child}.value[${keyArray}]`;

										return (
											<ChildAccordionArrayMapper
												path={path}
												fieldChild={fieldChild[child].value[keyArray]}
												index={keyArray}
												contextDictionary={contextDictionary}
												isEmpty={isEmpty}
												title={fieldChild[child][userLangage]}
												classes={classes}
												values={values}
												root={rootPathArray}
												rootPath={rootPathArrayDico}
												PI={PI}
												listAPIs={listAPIs}
												formDictionary={formDictionary}
												userLangage={userLangage}
												customErrors={customErrors}
												handleRemoveItemToArray={handleRemoveItemToArray}
												handleAddItemToArray={handleAddItemToArray}
												handleInputChangeValidate={handleInputChangeValidate}
												checkInputRequired={checkInputRequired}
												routeDict={routeDict}
												key={keyArray}
											/>
										);
									})}
								</>
							);
						} else if (
							fieldChild[child].type === "level" &&
							!fieldChild[child].isArray &&
							typeof fieldChild[child] === "object"
						) {
							let rootPathArray = root === "" ? `${root}` : root + `.${child}`;
							let rootPathArrayDico = rootPath === "" ? `${rootPath}` : rootPath + `.${child}`;
							return (
								<ChildAccordionArrayMapper
									path={path}
									fieldChild={fieldChild[child]}
									title={fieldChild[child][userLangage]}
									classes={classes}
									isEmpty={isEmpty}
									userLangage={userLangage}
									root={rootPathArray}
									rootPath={rootPathArrayDico}
									values={values}
									keyArray={key}
									listAPIs={listAPIs}
									PI={PI}
									handleInputChangeValidate={handleInputChangeValidate}
									checkInputRequired={checkInputRequired}
									formDictionary={formDictionary}
									handleRemoveItemToArray={handleRemoveItemToArray}
									handleAddItemToArray={handleAddItemToArray}
									customErrors={customErrors}
								></ChildAccordionArrayMapper>
							);
						} else if (
							fieldChild[child].type !== "level" &&
							typeof fieldChild[child] === "object"
						) {
							let rootPathArrayDico = rootPath === "" ? `${child}` : rootPath + `.${child}`;
							let rootPathArray = root === "" ? `${child}` : root + `.${child}`;
							let formConfig = lod_.get(formDictionary, rootPathArrayDico);
							return (
								<Box key={key}>
									<InputType
										regexEmail=""
										listAPIs={listAPIs}
										child={rootPathArray}
										whitelistDynamic={formConfig?.whitelistDynamic}
										linkAction={formConfig?.linkAction}
										isArray={formConfig?.isArray}
										whitelist={formConfig?.whitelist}
										isDisplay={formConfig?.display}
										codes={formConfig?.codes}
										label={fieldChild[child][userLangage]}
										isEdit={fieldChild[child]?.isEdit}
										isRequired={formConfig?.isRequired}
										key={key}
										PI={PI}
										isEmpty={isEmpty}
										type={formConfig?.type}
										valueForm={values}
										value={lod_.get(values, rootPathArray)}
										customErrors={lod_.get(customErrors, rootPathArray)}
										onChange={e => handleInputChangeValidate(e, formConfig, rootPathArray)}
										values={values}
										routeDict={routeDict}
										defaultValueForItem={fieldChild[child]?.defaultValue}
										checkRequired={valueInput => checkInputRequired(valueInput, rootPathArray)}
									></InputType>
								</Box>
							);
						} else {
							return null;
						}
					})}
			</AccordionDetails>
		</Accordion>
	);
};

export default ChildAccordionArrayMapper;
